import React from 'react';

import { Button, ButtonVariant } from '@/ui-library';
import { KeyValuePreview } from '@/ui-library/keyValuePreview';
import { TestFlowStatus } from '@/utils/types/test-flow.types';

export const ExtractText = ({
  data,
  onCancel,
  status,
}: {
  data?: Record<string, unknown>;
  onCancel: () => void;
  status: TestFlowStatus;
}) => {
  if (status === TestFlowStatus.WARNING) {
    return (
      <>
        <h2 className='text-NeutralDarkDarkest text-base not-italic font-black mb-5'>
          Your flow executed properly, but...
        </h2>
        <div className='flex flex-col gap-2 justify-center mb-8'>
          <p className='text-NeutralDarkLight mb-3'>
            No values were found. Try to add more labels in the AI Block or change the instructions and try again.
          </p>
          <div className='w-full flex gap-2 justify-center'>
            <Button variant={ButtonVariant.Secondary} onClick={onCancel}>
              Got it
            </Button>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <h2 className='text-NeutralDarkDarkest text-base not-italic font-black mb-5'>
        {data ? `We've extracted the following text` : `We've run over the input but nothing was found`}
      </h2>
      <div className='flex flex-col gap-2 mb-8'>
        {data && Object.keys(data).length > 0 ? (
          <KeyValuePreview
            data={Object.fromEntries(
              Object.entries(data).map(([key, value]) => [
                key,
                typeof value === 'string' ? value : JSON.stringify(value),
              ]),
            )}
          />
        ) : (
          <p className='text-NeutralDarkLight mb-3 text-center'>
            Try to add more labels in the AI Block or change the instructions and try again.
          </p>
        )}
      </div>
      <div className='w-full flex gap-2 justify-center'>
        <Button variant={ButtonVariant.Primary} onClick={onCancel}>
          Close
        </Button>
      </div>
    </>
  );
};
